"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFieldValidation = createFieldValidation;
exports.createValidationRules = createValidationRules;
exports["default"] = createFormValidation;
exports.mapFormValidation = mapFormValidation;
exports.nestFormValidation = nestFormValidation;
exports.createArrayFormValidation = createArrayFormValidation;
exports.createNestedFormValidation = createNestedFormValidation;

var _dotPropImmutable = _interopRequireDefault(require("dot-prop-immutable"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var DEFAULT_MESSAGE = 'Invalid';

var isArray = function isArray(value) {
  return value && _typeof(value) === 'object' && value.constructor === Array;
};

var composeFullPath = function composeFullPath(path, parentPath) {
  if (typeof parentPath === 'undefined') {
    return path;
  }

  return "".concat(parentPath, ".").concat(path);
};

function createFieldValidation(validate, message) {
  var defaultMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MESSAGE;
  return function (path, values, options, parentPath) {
    if (path.includes('*')) {
      var pathParts = path.split('.');

      var _pathParts = _slicedToArray(pathParts, 1),
          rootPart = _pathParts[0];

      var rootValue = _dotPropImmutable["default"].get(values, rootPart);

      return rootValue.map(function (nestedValues, i) {
        var validation = createFieldValidation(validate, message, defaultMessage);
        return validation(pathParts[2], nestedValues, options, "".concat(rootPart, ".").concat(i));
      }).reduce(_utils.flatten, []);
    }

    var value = _dotPropImmutable["default"].get(values, path);

    if (typeof value !== 'undefined' && !validate(value, values, options)) {
      var finalMessage = defaultMessage;

      if (typeof message === 'function') {
        finalMessage = message(value, values, options);
      }

      if (typeof message !== 'undefined') {
        finalMessage = message;
      }

      return [{
        path: composeFullPath(path, parentPath),
        message: finalMessage
      }];
    }

    return [];
  };
}

function createValidationRules(formRules, defaultMessage) {
  return formRules.map(function (rule) {
    var validation = rule.validation;

    if (typeof validation === 'undefined') {
      validation = createFieldValidation(rule.validate, rule.message, defaultMessage);
    }

    return {
      path: rule.path,
      validation: validation
    };
  });
}

function createFormValidation(formRules, defaultMessage) {
  var validationRules = createValidationRules(formRules, defaultMessage);
  return function (values, options, parentPath) {
    return validationRules.map(function (rule) {
      var messages = rule.validation(rule.path, values, options, parentPath);

      if (!isArray(messages)) {
        throw Error('A validation function must return an array of messages.');
      }

      return messages;
    }).reduce(_utils.flatten, []);
  };
}

function mapFormValidation(formValidation) {
  return function (path, values, options, parentPath) {
    var value = _dotPropImmutable["default"].get(values, path);

    return value.map(function (childValues, i) {
      return formValidation(childValues, options, composeFullPath("".concat(path, ".").concat(i), parentPath));
    }).reduce(_utils.flatten, []);
  };
}

function nestFormValidation(formValidation) {
  return function (path, value, otherValues, options) {
    return formValidation(value, options, path);
  };
}

function createArrayFormValidation(formRules, defaultMessage) {
  return mapFormValidation(createFormValidation(formRules, defaultMessage));
}

function createNestedFormValidation(formRules, defaultMessage) {
  return nestFormValidation(createFormValidation(formRules, defaultMessage));
}